// extracted by mini-css-extract-plugin
module.exports = {"plans":"PlanList_plans__TSe1w","plans__card--affiliate":"PlanList_plans__card--affiliate__XdXM3","plans--custom":"PlanList_plans--custom__qncSm"};